import OrbitApiV1 from '.'

class QuotationAPI {
  static getAllQuotations() {
    return OrbitApiV1.httpGet(`/quotation/list/all`)
  }

  static getOrgQuotations(orgId, limit) {
    return OrbitApiV1.httpGet(`/quotation/${orgId}/org?limit=${limit}`)
  }

  static createNewQuotation(quote, headers = {}) {
    return OrbitApiV1.httpPost(`/quotation/new/quote`, headers, quote)
  }
}

export default QuotationAPI
